import React from 'react';
import WavesIcon from '@mui/icons-material/Waves';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "River - Pumped" or "Underground - Pumped"' },
];

const WaterSourceManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Water Sources"
    icon={<WavesIcon />}
    apiPath="/api/water-sources"
    fields={fields}
    entityLabel="Water Source"
  />
);

export default WaterSourceManagement;
